import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type TransferReportFilters = {
  vin: string;
  keyword: string;
  title_inn: boolean;
  seller_id: number | null;
  buyer_id: number | null;
  status: string[];
  auction_ids: number[];
  payment_method: string[];
};

type TransferReportState = {
  page: number;
  perPage: number;
  filters: TransferReportFilters;
};

const initialState: TransferReportState = {
  page: 1,
  perPage: 20,
  filters: {
    vin: '',
    keyword: '',
    title_inn: false,
    seller_id: null,
    buyer_id: null,
    status: [],
    auction_ids: [],
    payment_method: [],
  },
};

const transferReportSlice = createSlice({
  name: 'transferReport',
  initialState,
  reducers: {
    setPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    setFilters(state, action: PayloadAction<Partial<TransferReportFilters>>) {
      state.filters = { ...state.filters, ...action.payload };
      state.page = 1;
    },
    resetTransferReport() {
      return initialState;
    },
  },
});

export const { setPage, setFilters, resetTransferReport } = transferReportSlice.actions;
export default transferReportSlice;
